<template>
  <el-dialog :destroy-on-close="true"
             title="分析路径说明"
             :visible.sync="showDialog"
             :before-close="handle"
             width="550px">
    <el-form :model="selectDetail" label-width="140px">
      <el-form-item label="服务器主机">
        <el-input v-model="selectDetail.hostName" readonly></el-input>
      </el-form-item>
      <el-form-item label="具体分析路径">
        <el-input v-model="selectDetail.analyzeDir" type="textarea"  :autosize="{ minRows: 4}" readonly></el-input>
      </el-form-item>
      <el-form-item label="项目资料">
        <el-input v-model="anaDataDir" type="textarea" :rows="4" readonly></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="handle">关 闭</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: "FileHostPathDialog",
  props:['showDialog','selectDetail'],
  data() {
    return {
      anaDataDir: ''
    }
  },
  watch:{
    'selectDetail.anaDataDir':{
      handler:function (newVal) {
        if(newVal){
          if (newVal.length>=2){
            newVal.forEach((item,index)=>{
              this.anaDataDir=this.anaDataDir+`路径${index+1}：${item}\n`
            })
          }else {
            this.anaDataDir=newVal[0]
          }
        }else {
          this.anaDataDir=''
        }
      },
      immediate:true
    }
  },

  methods:{
    handle(){
      this.$emit('submit')

    }
  }
}
</script>

<style scoped>

</style>
